(function () {
  'use strict';

  if (window.AxiomFooterReveal) return;

  // The whole footer group (Footer + Footer bottom panel) slides up from behind
  // the page content at half the scroll speed. section-footer.css applies the
  // offset only when the Footer section's reveal setting is on, on desktop.
  var SHELL_SELECTOR = '.footer-group-shell';
  var ENABLED_SELECTOR = '.footer[data-footer-reveal-enabled="true"]';
  var PARALLAX_RATIO = 0.5;
  var desktopQuery = window.matchMedia('(min-width: 768px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var frame = null;
  // Footer geometry is cached and only re-measured when layout changes, so scrolling reads
  // nothing but scrollY and writes only when the offset actually changes.
  var geometry = null;
  var needsMeasure = true;
  var lastOffset = null;

  function measure() {
    needsMeasure = false;
    var shell = document.querySelector(SHELL_SELECTOR);
    if (!shell || !desktopQuery.matches || reducedMotionQuery.matches || !shell.querySelector(ENABLED_SELECTOR)) {
      geometry = shell ? { shell: shell, enabled: false } : null;
      return;
    }
    // offsetTop/offsetHeight ignore transforms, so the offset never feeds back into itself.
    geometry = { shell: shell, enabled: true, top: shell.offsetTop, height: shell.offsetHeight };
  }

  function update() {
    frame = null;
    if (needsMeasure) measure();
    if (!geometry) return;

    if (!geometry.enabled) {
      if (lastOffset !== null) geometry.shell.style.removeProperty('--footer-reveal-offset');
      lastOffset = null;
      return;
    }

    var naturalBottom = geometry.top + geometry.height - window.scrollY;
    var remaining = Math.min(Math.max(naturalBottom - window.innerHeight, 0), geometry.height);
    var offset = Math.round(-remaining * PARALLAX_RATIO * 10) / 10;
    if (offset === lastOffset) return;
    lastOffset = offset;
    geometry.shell.style.setProperty('--footer-reveal-offset', offset + 'px');
  }

  function requestUpdate() {
    if (frame === null) frame = window.requestAnimationFrame(update);
  }

  function requestMeasure() {
    needsMeasure = true;
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestMeasure);
  window.addEventListener('load', requestMeasure);
  desktopQuery.addEventListener('change', requestMeasure);
  reducedMotionQuery.addEventListener('change', requestMeasure);
  document.addEventListener('shopify:section:load', requestMeasure);
  document.addEventListener('shopify:section:unload', requestMeasure);

  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(requestMeasure);
    var shell = document.querySelector(SHELL_SELECTOR);
    var main = document.getElementById('main-content');
    if (shell) resizeObserver.observe(shell);
    if (main) resizeObserver.observe(main);
  }

  requestUpdate();

  window.AxiomFooterReveal = { update: requestMeasure };
})();
